export const config = {
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  clerkPublishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  baseUrl: import.meta.env.VITE_BASE_URL,
  posthogKey: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
  posthogHost: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  firstDeliveryTerritoryIdEast: import.meta.env
    .VITE_PUBLIC_FIRST_DELIVERY_TERRITORY_ID_EAST,
  firstDeliveryTerritoryIdCentral: import.meta.env
    .VITE_PUBLIC_FIRST_DELIVERY_TERRITORY_ID_CENTRAL,
  firstDeliveryTerritoryIdMountain: import.meta.env
    .VITE_PUBLIC_FIRST_DELIVERY_TERRITORY_ID_MOUNTAIN,
  firstDeliveryTerritoryIdPacific: import.meta.env
    .VITE_PUBLIC_FIRST_DELIVERY_TERRITORY_ID_PACIFIC,
} as const;
